<div class="add-container">
    <div class="flex flex-row justify-between pb-10">
        <div class="flex flex-row">
            <div class="flex flex-col">
                <div class="mat-headline-5 mb-6 fw-700">{{ title }}</div>
            </div>
        </div>
        <mat-icon svgIcon="close" class="close-icon" (click)="sidenavService.closeRightSidenav()"></mat-icon>
    </div>
    <mat-divider class="mb-20 neutral-2"></mat-divider>
    <form [formGroup]="createComponentForm" class="pl-8 pb-8">
        <div class="p-24" class="form-section pr-18">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.COMPONENT_NAME' | transloco |
                            uppercase}}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.ADD_COMPONENTS' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="name" placeholder="{{'COMPONENTS.ADD_COMPONENTS' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('name')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.COMPONENT_VERSION' | transloco |
                            uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.COMPONENT_VERSION' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="version"
                        placeholder="{{'COMPONENTS.COMPONENT_VERSION' | transloco}}" class="fw-500" required>
                    <app-error [control]="createComponentForm.get('version')"></app-error>
                </div>
            </div>
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.COMPONENT_TYPE' | transloco |
                            uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.COMPONENT_TYPE' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="componentType" placeholder="{{'COMPONENTS.COMPONENT_TYPE' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('componentType')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.DEPLOYED_FORM' | transloco |
                            uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.DEPLOYED_FORM' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="deployedForm" placeholder="{{'COMPONENTS.DEPLOYED_FORM' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('deployedForm')"></app-error>
                </div>
            </div>
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.DISPLAY_NAME' | transloco |
                            uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.DISPLAY_NAME' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="displayName" placeholder="{{'COMPONENTS.DISPLAY_NAME' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('displayName')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.DEPLOYED_NAME' | transloco |
                            uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.DEPLOYED_NAME' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="deployedName" placeholder="{{'COMPONENTS.DEPLOYED_NAME' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('deployedName')"></app-error>
                </div>
            </div>
            <div class="flex flex-col mb-16">
                <div class="flex flex-row justify-start items-center">
                    <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.SHORT_DESCRIPTION' |
                        transloco}}</label>
                    <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                        [matTooltip]="'COMPONENTS.SHORT_DESCRIPTION' | transloco"
                        matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <textarea formControlName="shortDescription" placeholder="{{'COMPONENTS.DESCRIPTION_HERE' | transloco}}"
                    class="fw-500 text-area" required></textarea>
                <app-error [control]="createComponentForm.get('shortDescription')"></app-error>
            </div>
            <div class="flex flex-row gap-8 mt-10">
                <div class="flex flex-col form-fields">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.DEPENDENCIES' | transloco |
                            uppercase
                            }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.DEPENDENCIES' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="dependencies" placeholder="{{'COMPONENTS.DEPENDENCIES' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('dependencies')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.LISTERN_TO' | transloco |
                            uppercase
                            }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.LISTERN_TO' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="listernTo" placeholder="{{'COMPONENTS.LISTERN_TO' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('listernTo')"></app-error>
                </div>
            </div>
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.INFRA' | transloco | uppercase
                            }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.INFRA' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="infra" placeholder="{{'COMPONENTS.INFRA' | transloco}}" class="fw-500"
                        required>
                    <app-error [control]="createComponentForm.get('infra')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.PROVIDES' | transloco |
                            uppercase}}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.PROVIDES' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="provides" placeholder="{{'COMPONENTS.PROVIDES' | transloco}}" class="fw-500"
                        required>
                    <app-error [control]="createComponentForm.get('provides')"></app-error>
                </div>
            </div>
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.PUBLISHES' | transloco |
                            uppercase
                            }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.PUBLISHES' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="publishes" placeholder="{{'COMPONENTS.PUBLISHES' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('publishes')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.PARAMATERS' | transloco |
                            uppercase}}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.PARAMATERS' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="parameters" placeholder="{{'COMPONENTS.PARAMATERS' | transloco}}"
                        class="fw-500" required>
                    <app-error [control]="createComponentForm.get('parameters')"></app-error>
                </div>
            </div>
            <div class="flex flex-col mb-16">
                <div class="flex flex-row justify-start items-center">
                    <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.INSTALLATION_SPECIFICATION' |
                        transloco}}</label>
                    <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                        [matTooltip]="'COMPONENTS.INSTALLATION_SPECIFICATION' | transloco"
                        matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <textarea formControlName="installSpecification"
                    placeholder="{{'COMPONENTS.INSTALLATION_SPECIFICATION' | transloco}}" class="fw-500 text-area"
                    required></textarea>
                <app-error [control]="createComponentForm.get('installSpecification')"></app-error>
            </div>
            <div class="flex flex-col mt-8 mb-16">
                <div class="flex flex-row justify-start items-center">
                    <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.SECRET_SPECIFICATION' |
                        transloco}}</label>
                    <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                        [matTooltip]="'COMPONENTS.SECRET_SPECIFICATION' | transloco"
                        matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <textarea formControlName="secretSpecification"
                    placeholder="{{'COMPONENTS.SECRET_SPECIFICATION' | transloco}}" class="fw-500 text-area"
                    required></textarea>
                <app-error [control]="createComponentForm.get('secretSpecification')"></app-error>
            </div>
            <div class="flex flex-row gap-8 mt-8">
                <div class="flex flex-col form-fields">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'COMPONENTS.ACTION' | transloco | uppercase
                            }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
                            [matTooltip]="'COMPONENTS.ACTION' | transloco"
                            matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="action" placeholder="{{'COMPONENTS.ACTION' | transloco}}" class="fw-500"
                        required>
                    <app-error [control]="createComponentForm.get('action')"></app-error>
                </div>
            </div>
        </div>

        <div class="footer pt-16 mt-20">
            <div class="flex flex-row gap-x-6 justify-end">
                <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' |
                    transloco}}</button>
                <button class="accent" type="button" (click)="addComponent()">{{textbutton}}</button>
            </div>
        </div>
    </form>
</div>
<div class="overlay" *ngIf="isLoading">
    <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>